/**
 * @desc - もっと見るボタン
 * @link - http://gimmicklog.main.jp/jquery/490/
 */

$(function () {
  $('.morebutton').prevAll().hide();
  $('.morebutton').click(function () {
    if ($(this).prevAll().is(':hidden')) {
      $(this).prevAll().slideDown();
      $(this).text('閉じる').addClass('close');
    } else {
      $(this).prevAll().slideUp();
      $(this).text('レビューをもっと見る').removeClass('close');
    }
  });
});